import React, { ButtonHTMLAttributes } from 'react'
import { cn } from 'shared-utilities'

export const FormButton = ({
  variant = 'primary',
  children,
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  className?: string
  variant?: 'primary' | 'secondary'
}) => {
  const baseClasses =
    'flex items-center justify-center h-10 gap-3 rounded px-5 text-2026-inverse w-full disabled:bg-gray-8 disabled:text-2026-form-gray-light'
  const variantClasses = {
    primary: 'bg-2026-form-blue text-2026-inverse',
    secondary: 'bg-transparent text-2026-form-gray-light',
  }
  return (
    <button
      className={cn(baseClasses, variantClasses[variant], className)}
      {...props}
    >
      {children}
    </button>
  )
}
